import { render } from "./Loops.vue?vue&type=template&id=9914d826&scoped=true"
import script from "./Loops.vue?vue&type=script&lang=js"
export * from "./Loops.vue?vue&type=script&lang=js"

import "./Loops.vue?vue&type=style&index=0&id=9914d826&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9914d826"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QInnerLoading,QBtn,QBtnGroup});
